import { useQuery } from '@apollo/client/react';
import { DataTable } from '@optools/components/data-table/data-table';
import { DataTableColumnHeader } from '@optools/components/data-table/data-table-column-header';
import { ScrollPage } from '@optools/components/layout/layout';
import { PageTitle } from '@optools/components/layout/typography';
import { PageLoader } from '@optools/components/loading/page-loader';
import { SEARCH_MULTICAST_MAPPING } from '@optools/services/operator-gateway/btc/queries';
import { PipelineMulticastMapping } from '@optools/services/operator-gateway/types/generated/graphql';
import { AddMulticastMapping } from '@optools/tools/btc-tools/components/add-multicast-mapping';
import { DeleteMulticastMapping } from '@optools/tools/btc-tools/components/delete-multicast-mapping';
import { UpdateMulticastMapping } from '@optools/tools/btc-tools/components/update-multicast-mapping';
import { createFileRoute } from '@tanstack/react-router';
import { ColumnDef } from '@tanstack/react-table';

export const Route = createFileRoute('/_auth/btc-tools/configs/multicast-mappings')({
  component: RouteComponent,
});

const columns: ColumnDef<PipelineMulticastMapping>[] = [
  {
    accessorKey: 'id',
    enableSorting: true,
    header: ({ column }) => <DataTableColumnHeader column={column} title="ID" />,
    id: 'ID',
  },
  {
    accessorKey: 'callSign',
    enableSorting: true,
    header: ({ column }) => <DataTableColumnHeader column={column} title="Call Sign" />,
    id: 'Call Sign',
  },
  {
    accessorKey: 'priority',
    enableSorting: true,
    header: ({ column }) => <DataTableColumnHeader column={column} title="Priority" />,
    id: 'Priority',
  },
  {
    accessorKey: 'region',
    enableSorting: true,
    header: ({ column }) => <DataTableColumnHeader column={column} title="Region" />,
    id: 'Region',
  },
  {
    accessorKey: 'sourceLocation',
    enableSorting: true,
    header: ({ column }) => <DataTableColumnHeader column={column} title="Source Location" />,
    id: 'Source Location',
  },
  {
    accessorKey: 'multicastAddress',
    enableSorting: true,
    header: ({ column }) => <DataTableColumnHeader column={column} title="Multicast Address" />,
    id: 'Multicast Address',
  },
  {
    accessorKey: 'hdrMulticastAddress',
    enableSorting: true,
    header: ({ column }) => <DataTableColumnHeader column={column} title="HDR Multicast Address" />,
    id: 'HDR Multicast Address',
  },
  {
    cell: (row) => {
      return (
        <div className="flex justify-end gap-2">
          <UpdateMulticastMapping multicastMapping={row.cell.row.original} />
          <DeleteMulticastMapping multicastMapping={row.cell.row.original} />
        </div>
      );
    },
    id: 'actions',
  },
];

export function RouteComponent() {
  const { data, loading } = useQuery(SEARCH_MULTICAST_MAPPING);

  if (loading) {
    return <PageLoader />;
  }

  return (
    <ScrollPage>
      <PageTitle>Multicast Mappings</PageTitle>

      <DataTable columns={columns} data={data?.searchMulticastMappings ?? []}>
        <AddMulticastMapping />
      </DataTable>
    </ScrollPage>
  );
}
